































import { Component, Vue, Watch, Prop, Model } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Cascader } from 'element-ui';
import { complexClone } from '@acgn/herm/src/util/serialize';

const StaffAction = namespace('desk/staff').Action;

const AuthGetter = namespace('desk/auth').Getter;
const StaffGetter = namespace('desk/staff').Getter;

@Component({
  components: {
    [Cascader.name]: Cascader
  }
})

/**
 * 统计图表人员选择
 */
export default class AcgnStaffCake extends Vue {
  public name: string = 'AcgnStaffCake';

  @Model('change', { required: true }) public value: number | number[];
  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 成员id
  @Prop({ default: 1 }) public maxnum: number; // 最大选中数量
  @Prop({ default: false }) public multiple: boolean; // 是否多选
  @Prop({ default: true }) public initVal: boolean; // 是否初始化选中
  @Prop({ default: 'small' }) public size: string; // ui尺寸
  @Prop({ default: false }) public isSelectLoginUser: boolean; // 是否默认选择登录用户
  @Prop({ default: 'width:100px;' }) public inputStyle: string | null; // 输入框样式

  @StaffAction private getDepartUserList: any; // 获取部门成员
  @StaffAction private getComicStaffList: any; // 获取项目成员

  @AuthGetter private userInfo: any;
  @StaffGetter private departStaffList: any; // 团队成员列表
  @StaffGetter private comicStaffList: any; // 项目成员列表

  private selectCascaderVal: any = null; // 级联框人员数据
  private staffId: any = null; // 选择的员工
  private loadComplete: any = false; // 加载数据完成

  // 监听外部清除操作(多选操作，外部清除触发这里的清除)
  @Watch('value', { immediate: true, deep: true })
  private watchValue(v: any) {
    if (!this.value || (this.value as any).length === 0) {
      this.staffId = null;
      this.selectCascaderVal = null;
    }
  }

  private async created() {
    await this.getUserList();
    this.loadComplete = true;
  }

  private get staffList() {
    const list: any = this.filterStaff();
    if (!this.initVal) {
      return list;
    }
    // 默认选中第一个成员
    if (list.length > 0 && !this.staffId && this.loadComplete) {
      if (this.comicId) {
        this.staffId = this.isSelectLoginUser ? this.userInfo.id : list[0].id;
      } else {
        const re = this.getCascaderVal(list[0]);
        this.selectCascaderVal = re;
        this.staffId = this.isSelectLoginUser ? this.userInfo.id : re[re.length - 1];
      }
      this.fire();
    }
    return list;
  }

  private filterStaff() {
    const list: any = this.comicId ? this.comicStaffList : this.departStaffList;
    if (!this.userId) {
      return list;
    }
    // 项目人员筛选
    if (this.comicId) {
      return list.filter((item: any) => item.id !== this.userId);
    }

    // 团队人员筛选
    const cloneList: any = complexClone(list);
    return this.cascaderStaff(cloneList);
  }

  // 级联遍历去除自己
  private cascaderStaff(list: any) {
    return list.filter((item: any) => {
      if (item.children && item.children.length) {
        item.children = this.cascaderStaff(item.children);
      }
      return item.value !== this.userId;
    });
  }

  private getCascaderVal(data: any): any {
    const vals = [];
    vals.push(data.value);
    if (!data.children || data.children.length === 0) {
      return vals;
    }
    vals.push(...this.getCascaderVal(data.children[0]));
    return vals;
  }

  private async getUserList() {
    if (this.comicId) {
      await this.getComicStaffList({ project_id: this.comicId });
    } else {
      await this.getDepartUserList({ dept_id: this.userInfo.now_dept.id });
    }
  }

  private fire() {
    this.$emit('change', this.staffId);
  }

  private handleChange() {
    const length = this.selectCascaderVal.length;
    if (length === 0) {
      this.staffId = null;
      return;
    }
    if (typeof this.selectCascaderVal[0] !== 'number') {
      this.staffId = [];
      if (length > this.maxnum) {
        this.$message.warning(`最多可选择${this.maxnum}位对比人员`);
        this.selectCascaderVal = this.selectCascaderVal.slice(0, this.maxnum);
      }
      this.selectCascaderVal.map((item: any) => {
        this.staffId.push(item[item.length - 1]);
      });
    } else {
      this.staffId = this.selectCascaderVal[length - 1];
    }

    this.fire();
  }

  private seelectChange() {
    this.fire();
  }
}
